/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Command_AriaInputs */

const en_directory_home_hero_command_aria = /** @type {(inputs: Directory_Home_Hero_Command_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI agent submission command`)
};

const zh_directory_home_hero_command_aria = /** @type {(inputs: Directory_Home_Hero_Command_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agent 提交命令`)
};

/**
* | output |
* | --- |
* | "AI agent submission command" |
*
* @param {Directory_Home_Hero_Command_AriaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_command_aria = /** @type {((inputs?: Directory_Home_Hero_Command_AriaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Command_AriaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_command_aria(inputs)
	return zh_directory_home_hero_command_aria(inputs)
});
export { directory_home_hero_command_aria as "directory.home.hero.command_aria" }